import request from '@/utils/request'

// 查询当前用户可见的快捷导航列表
export function listQuickNav() {
  return request({
    url: '/wms/quickNav/list',
    method: 'get'
  })
}

// 查询快捷导航配置专用菜单树（仅管理员）
export function getQuickNavMenuTree() {
  return request({
    url: '/wms/quickNav/menuTree',
    method: 'get'
  })
}

// 保存快捷导航配置（仅管理员，整体替换）
export function saveQuickNav(data) {
  return request({
    url: '/wms/quickNav/save',
    method: 'post',
    data: data
  })
}
